module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pV"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/list_of_maps.htm"
    }
  }, [_c('i', [_vm._v("List of Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements.htm"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction.htm"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch1.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("1")]), _vm._v(" The Origins of the Naval Offensive")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch2.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("2")]), _vm._v(" From Ships to Troops")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch3.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("3")]), _vm._v(" The Worst-Laid Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch4.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("4")]), _vm._v(" The Rise and Fall of the Naval Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch5.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("5")]), _vm._v(" No Going Back")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch6.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("6")]), _vm._v(" The Military Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch7.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("7")]), _vm._v(" Bodies Everywhere: The Helles Landings")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch8.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("8")]), _vm._v(" A Perfect Hail of Bullets: Landing and Consolidation at Anzac")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch9.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("9")]), _vm._v(" The Killing Fields of Krithia")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch10.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("10")]), _vm._v(" Last Throw in the South")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch11.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("11")]), _vm._v(" The Plans of August")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch12.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("12")]), _vm._v(" The Assault on Sari Bair")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch13.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("13")]), _vm._v(" Suvla Bay: The Scapegoat Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch14.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("14")]), _vm._v(" ‘War as we must’: The Political Debate")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch15.htm"
    }
  }, [_c('span', {
    staticClass: "contentblock"
  }, [_vm._v("15")]), _vm._v(" A Campaign Not Won")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/reflections_on_gallipoli.htm"
    }
  }, [_vm._v("Reflections on Gallipoli")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/bibliography.htm"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0